import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { HttpClientModule } from '@angular/common/http';
import { NgxPayPalModule } from 'ngx-paypal';
import { NgxSpinnerModule } from 'ngx-spinner';
// import { NgcCookieConsentModule } from 'ngx-cookieconsent';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RatingModule } from 'ng-starrating';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertModule } from './components/_alert';
import { Ng5SliderModule } from 'ng5-slider';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSelectModule } from 'ngx-select-ex';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule} from '@angular/material/toolbar';
import { MatBadgeModule} from '@angular/material/badge';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PagesModule } from './newPages/pages.module';
import { ComponentsModule } from './newComponents/components.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TranslocoRootModule } from './transloco/transloco.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatIconModule,
    HttpClientModule,
    NgxPayPalModule,
    NgxSpinnerModule,
    HttpClientModule,
    MatSnackBarModule,
    MatFormFieldModule,
    RatingModule,
    FormsModule,
    ReactiveFormsModule,
    AlertModule,
    Ng5SliderModule,
    NgSelectModule,
    NgxSelectModule,
    MatToolbarModule,
    MatBadgeModule,
    MatCardModule,
    MatMenuModule,
    MatButtonModule,
    PagesModule,
    ComponentsModule,
    MatSidenavModule,
    TranslocoRootModule
  ],
  providers: [
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
